import { Component, OnInit } from '@angular/core';
import {Message} from "primeng/primeng";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Gasto} from "./gasto";
import {GastoService} from "../Services/gasto.service";
import {TiendaService} from "../Services/tienda.service";
import {Tienda} from "../tienda/tienda";
import {Usuario} from "../usuario/Usuario";
import {UsuarioService} from "../Services/usuario.service";

@Component({
  selector: 'app-gasto',
  templateUrl: './gasto.component.html',
  styleUrls: ['./gasto.component.css']
})
export class GastoComponent implements OnInit {

  msgs: Message[] = [];
  formGasto : FormGroup;
  btnNuevo = true;
  btnCancelar = false;
  btnGuardar = false;
  btnGuardarEditar = false;
  tiposDocumento = [];
  panelRequeridos = false;
  loading = false;
  GastosRegistrados:Gasto[];
  GastoSeleccionado:Gasto;
  tipoGuardado = '';
  TiendasRegistrados:Tienda[];


  constructor(private servicioTienda:TiendaService,
              private servicioGasto:GastoService,
              private fb: FormBuilder) { }

  ngOnInit() {
    this.crearControlesGasto();
    this.Cancelar();
    this.poblarTiposDoc();
    this.listarGastos();
    this.listarTiendas();
  }

  crearControlesGasto(){
    this.formGasto = this.fb.group({
      descripcion:['',Validators.required],
      valor:['',Validators.required],
      tienda_id:['',Validators.required],
      usuario_id:[''],
      }
    );

  }
  nuevoGasto(){
    this.btnNuevo = false;
    this.btnGuardar = true;
    this.btnGuardarEditar = false;
    this.btnCancelar = true;
    this.formGasto.enable();
    this.formGasto.reset();
    this.panelRequeridos = true;
    this.tipoGuardado = 'guardar';

  }
  Cancelar(){
    this.btnGuardar = false;
    this.btnNuevo = true;
    this.btnCancelar = false;
    this.btnGuardarEditar = false;
    this.formGasto.reset();
    this.formGasto.disable();
    this.panelRequeridos = false;
  }
  poblarTiposDoc(){
    this.tiposDocumento.push({label:'Seleccione un Tipo', value:''});
    this.tiposDocumento.push({label:'C.C', value:'C.C'});
    this.tiposDocumento.push({label:'PASAPORTE', value:''});
    this.tiposDocumento.push({label:'C.E.', value:''});
    this.tiposDocumento.push({label:'DNI', value:''});
    this.tiposDocumento.push({label:'NIT', value:''});
    this.tiposDocumento.push({label:'NUIP', value:''});
  }
  mensajes(severity,summary,detail){
    this.msgs = [];
    this.msgs.push({severity:severity, summary:summary, detail:detail});
  }
  guardarNuevoGasto(){
    if(this.tipoGuardado == 'editar'){
      this.loading = true;
      this.servicioGasto.putGasto(this.formGasto.value,this.GastoSeleccionado.id)
        .subscribe(
          rt => {
            this.mensajes('success','Actualizacion',rt);
            this.listarGastos();
            this.loading = false;
          },
          er => this.mensajes('error','Error',er),
          () =>  {
            this.Cancelar();
          });
    }
    else if(this.tipoGuardado == 'guardar') {
      this.loading = true;
      this.servicioGasto.addGasto(this.formGasto.value)
        .subscribe(
          rt => {
            this.mensajes('success','Guardar',rt);
            this.listarGastos();
            this.loading = false;
          },
          er => this.mensajes('error','Error',er),
          () =>  {
            this.Cancelar();
          });
    }
    this.tipoGuardado = '';
  }
  listarGastos(){
    this.loading = true;
    this.servicioGasto.getGasto()
      .subscribe(
        rt => {
          this.GastosRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  seleccionarGasto(item:Gasto){
    this.btnNuevo = false;
    this.btnGuardar = false;
    this.btnGuardarEditar = true;
    this.btnCancelar = true;
    this.formGasto.enable();
    this.panelRequeridos = true;
    this.GastoSeleccionado = item;
    this.GastoDetalle(item);
    this.tipoGuardado = 'editar';
  }
  GastoDetalle(item:Gasto):void {
   this.formGasto.patchValue({
   id:item.id,
     descripcion:item.descripcion,
     valor:item.valor,
     Usuario_id:item.usuario_id,
     tienda_id:item.tienda_id,
   });
   }
  listarTiendas(){
    this.loading = true;
    this.servicioTienda.getTienda()
      .subscribe(
        rt => {
          this.TiendasRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
}



// WEBPACK FOOTER //
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/gasto/gasto.component.ts